<script>
import kerdarLang from "@/components/kerdar/utils/langResource.json"
import { avandDuration } from "@/components/kerdar/utils/duration"
import AvandTransactionCount from "@/components/kerdar/tabs/avand/elements/AvandTransactionCount.vue"
import AvandTransactionCreditAndDebit from "@/components/kerdar/tabs/avand/elements/AvandTransactionCreditAndDebit.vue"
import AvandTransactionMinAndMaxBalance from "@/components/kerdar/tabs/avand/elements/AvandTransactionMinAndMaxBalance.vue"

export default {
  name: "index",
  components: {
    AvandTransactionCount,
    AvandTransactionCreditAndDebit,
    AvandTransactionMinAndMaxBalance,
  },
  data() {
    return {
      kerdarLang,
      avandDuration,
    }
  },
}
</script>

<template>
  <div>
    <v-layout class="my-3 font_5 bold">
      <v-flex>تعداد تراکنش‌های حساب‌های متصل به آوند</v-flex>
    </v-layout>
    <AvandTransactionCount
      :duration="avandDuration"
      :kerdar-lang="kerdarLang"
    />
    <v-layout class="mb-3 mt-10 font_5 bold">
      <v-flex>حداقل و حداکثر موجودی هر حساب</v-flex>
    </v-layout>
    <AvandTransactionMinAndMaxBalance
      :duration="avandDuration"
      :kerdar-lang="kerdarLang"
    />
    <v-layout class="mb-3 mt-10 font_5 bold">
      <v-flex>حجم تراکنش‌های واریز و برداشت</v-flex>
    </v-layout>
    <AvandTransactionCreditAndDebit
      :duration="avandDuration"
      :kerdar-lang="kerdarLang"
    />
  </div>
</template>

<style scoped lang="scss"></style>
